// leave in this line to fix IE (https://sentry.io/organizations/zgny/issues/1897442680/)
import "core-js/features/array/from";

import { ApolloClient, HttpLink, InMemoryCache } from "@apollo/client";
import { setContext } from "apollo-link-context";
import { createUploadLink } from "apollo-upload-client";
import { canUseDOM } from "exenv";
import Cookie from "js-cookie";
import { fetch } from "whatwg-fetch";

import graphqlEndpoint from "../../constants/graphql-endpoint";
import possibleTypes from "./possibleTypes";

const apolloHeaders = { os: "web" };
if (canUseDOM) {
  const userAuthToken = Cookie.get("user_auth_token", {
    domain: global.location.host
  });
  if (userAuthToken) {
    apolloHeaders.Authorization = userAuthToken;
  }
}

const authLink = setContext((_, { headers }) => ({
  headers: {
    ...headers,
    ...apolloHeaders
  }
}));

export const createNewInMemoryCache = config =>
  new InMemoryCache({ possibleTypes, ...config });

export const createNewApolloClient = (
  options = {},
  cacheConfig = {},
  isUploadLink = false
) => {
  let link;

  if (!isUploadLink) {
    const httpLink = new HttpLink({
      uri: graphqlEndpoint,
      fetch,
      credentials: options?.credentials || false
    });
    link = authLink.concat(httpLink);
  } else {
    const uploadLink = createUploadLink({
      uri: graphqlEndpoint,
      fetch,
      credentials: options?.credentials || false
    });
    link = authLink.concat(uploadLink);
  }
  return new ApolloClient({
    link,
    connectToDevTools: process.env.NODE_ENV === "development",
    cache: createNewInMemoryCache(cacheConfig),
    defaultOptions: {
      query: {
        fetchPolicy: "cache-first",
        errorPolicy: "all"
      }
    },
    ...options
  });
};

const apolloClient = createNewApolloClient();
const apolloUploadClient = createNewApolloClient({}, {}, true);

export { apolloUploadClient };
/* eslint-disable  import/no-unused-modules */
export default apolloClient;
/* eslint-enable  import/no-unused-modules */
